import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=235a5380&"
import script from "./VideoBox.vue?vue&type=script&lang=js&"
export * from "./VideoBox.vue?vue&type=script&lang=js&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235a5380')) {
      api.createRecord('235a5380', component.options)
    } else {
      api.reload('235a5380', component.options)
    }
    module.hot.accept("./VideoBox.vue?vue&type=template&id=235a5380&", function () {
      api.rerender('235a5380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoBox.vue"
export default component.exports